import { ButtonCus } from '@/components/common/Button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/common/Form';
import { Textarea } from '@/components/common/Textarea';
import { useStore } from '@/hooks/useStore';
import yup from '@/services/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface RequestUpdateOrderProps {
    id: number,
    reload?: Function
}
export default observer(function RequestUpdateOrder({ id, reload }: RequestUpdateOrderProps) {
    // hook
    const { t } = useTranslation();

    // store
    const { reservationStore: { requestUpdateBookingByCustomer }, modalStore: { hideAllModals, showAlertModal } } = useStore();
    // validate schema
    const validateSchema = yup.object().shape({
        note: yup
            .string()
            .trim().required('form_error_validate.required')
    });

    type FormData = yup.InferType<typeof validateSchema>;

    // state
    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        mode: 'onChange',
        defaultValues: {
            note: ''
        }
    });

    // function
    const onSubmit = async (data: FormData) => {
        const payload = {
            id, note: data.note
        };
        const res = await flowResult(requestUpdateBookingByCustomer(payload));
        if (res) {
            hideAllModals();
            showAlertModal({
                id: 'update-success',
                type: 'success',
                content: <p className='whitespace-pre-line text-center'>{t('messages.request_update_success')}</p>
            });
        } else {
            showAlertModal({
                id: 'update-fail',
                type: 'error',
                content: t('messages.send_failure')
            });
        }
    };

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
                <div>
                    <FormField
                        control={form.control}
                        name='note'
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel required>{t('words_title.note')}</FormLabel>
                                <FormControl>
                                    <Textarea {...field} rows={5} maxLength={500} placeholder={t('placeholder.enter')}></Textarea>
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div>
                <div>
                    <div className='mt-8 flex justify-center'>
                        <ButtonCus variant='default' disabled={form.formState.isSubmitting} size='sm' type='submit'>{t('button.send')}</ButtonCus>
                    </div>
                </div>
            </form>
        </Form>
    );
});
